import React from 'react';
import styled from 'styled-components';
import Utility from '../../../../util/utilityfunctions';
import {useOverrideLabels} from '../../../Main/Forms/Utilities/OverrideLabelsProvider';
import EllipseControl from '../../EllipsesControl/EllipsesControl';
import DefineRiskItem from './DefineRiskItem';

const DefineRiskList = ({headerName, taskShortName, riskFactorsList}) => {
	const riskHeaderName = `${taskShortName} - ${headerName}`;

	const {labels} = useOverrideLabels();

	return (
		<>
			<StyledDefineRiskList className="StyledDefineRiskListLI">
				<span className="riskfactor-type">
					<EllipseControl
						content={riskHeaderName}
						tooltip={riskHeaderName}
						noOfLines={1}
						tooltipClass="tooltipCustomWidth"
					/>
				</span>
				<ul className="riskfactor-typelist">
					{riskFactorsList.length > 0 ? (
						riskFactorsList.sort(Utility.sortByMultipleKey('riskFactorName')).map((riskFactorItem) => (
							<>
								<DefineRiskItem key={'riskFactorItem' + riskFactorItem.riskFactorID} item={riskFactorItem} />
							</>
						))
					) : (
						<section className="empty-template">
							<span className="no-risks">{labels.noRiskFactors}</span>
						</section>
					)}
				</ul>
			</StyledDefineRiskList>
		</>
	);
};

export default DefineRiskList;

const StyledDefineRiskList = styled.li``;
